export const VideoStorage = {
    objectUrl: null,
    size: 0
};


// WEBPACK FOOTER //
// ./src/services/VideoStorage.js